import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'facebook',
            't24.com.tr',
            'google',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'facebook',
            't24.com.tr',
            'google',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'tr.mashable.com',
                value: 'tr.mashable.com',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Son Dakika', value: 'son dakika' },
            { label: 'Euro 2024', value: 'euro 2024' },
            { label: 'Video', value: 'video' },
            { label: 'Yazarlar', value: 'yazarlar' },
            { label: 'Gündem', value: 'gündem' },
            { label: 'T24 Haftalık', value: 't24 haftalık' },
            { label: 'Kitap24', value: 'kitap24' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Diğer', value: 'diğer' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'adnan ekinci', value: 'adnan ekinci' },
            { label: 'ahmet çelik kurtoğlu', value: 'ahmet çelik kurtoğlu' },
            { label: 'ahmet şık', value: 'ahmet şık' },
            { label: 'ahmet talimciler', value: 'ahmet talimciler' },
            { label: 'akdoğan özkan', value: 'akdoğan özkan' },
            { label: 'alex akimoğlu', value: 'alex akimoğlu' },
            { label: 'ali akay', value: 'ali akay' },
            { label: 'ali alpar', value: 'ali alpar' },
            { label: 'ali d. ulusoy', value: 'ali d. ulusoy' },
            { label: 'altan öymen', value: 'altan öymen' },
            { label: 'asena özkan', value: 'asena özkan' },
            { label: 'aslı atasoy', value: 'aslı atasoy' },
            { label: 'atilla dorsay', value: 'atilla dorsay' },
            { label: 'aydın engin', value: 'aydın engin' },
            { label: 'ayşe acar', value: 'ayşe acar' },
            { label: 'aytun aktan', value: 'aytun aktan' },
            { label: 'barçın yinanç', value: 'barçın yinanç' },
            { label: 'barış soydan', value: 'barış soydan' },
            { label: 'baskın oran', value: 'baskın oran' },
            { label: 'bekir ağırdır', value: 'bekir ağırdır' },
            { label: 'binhan elif yılmaz', value: 'binhan elif yılmaz' },
            { label: 'binnaz saktanber', value: 'binnaz saktanber' },
            { label: 'çağnur öztürk', value: 'çağnur öztürk' },
            { label: 'candan yıldız', value: 'candan yıldız' },
            { label: 'cansu çamlıbel', value: 'cansu çamlıbel' },
            { label: 'celal üster', value: 'celal üster' },
            { label: 'çelik kurtoğlu', value: 'çelik kurtoğlu' },
            { label: 'cemal tunçdemir', value: 'cemal tunçdemir' },
            { label: 'cengiz çandar', value: 'cengiz çandar' },
            { label: 'cevdet kadri kırımlı', value: 'cevdet kadri kırımlı' },
            { label: 'çiğdem anad', value: 'çiğdem anad' },
            { label: 'çiğdem toker', value: 'çiğdem toker' },
            { label: 'deniz can', value: 'deniz can' },
            { label: 'doğan akın', value: 'doğan akın' },
            { label: 'ebru d. dedeoğlu', value: 'ebru d. dedeoğlu' },
            { label: 'ercan uygur', value: 'ercan uygur' },
            { label: 'erdoğan işcan', value: 'erdoğan işcan' },
            { label: 'erdoğan sağlam', value: 'erdoğan sağlam' },
            { label: 'ersan şen', value: 'ersan şen' },
            { label: 'evren balta', value: 'evren balta' },
            { label: 'faruk bildirici', value: 'faruk bildirici' },
            { label: 'fikret bila', value: 'fikret bila' },
            { label: 'füsun sarp nebil', value: 'füsun sarp nebil' },
            { label: 'gökçer tahincioğlu', value: 'gökçer tahincioğlu' },
            { label: 'göksun gökçe göndermez', value: 'göksun gökçe göndermez' },
            { label: 'hakan aksay', value: 'hakan aksay' },
            { label: 'hande çayır', value: 'hande çayır' },
            { label: 'hasan cemal', value: 'hasan cemal' },
            { label: 'hasan göğüş', value: 'hasan göğüş' },
            { label: 'hasan servet öktem', value: 'hasan servet öktem' },
            { label: 'hazal özvarış', value: 'hazal özvarış' },
            { label: 'i̇klim masası', value: 'i̇klim masası' },
            { label: 'ilgaz çınar', value: 'ilgaz çınar' },
            { label: 'i̇skender aruoba', value: 'i̇skender aruoba' },
            { label: 'kamil yılmaz', value: 'kamil yılmaz' },
            { label: 'karel valansi', value: 'karel valansi' },
            { label: 'levent kurnaz', value: 'levent kurnaz' },
            { label: 'levent yılmaz ', value: 'levent yılmaz ' },
            { label: 'm. k. perker', value: 'm. k. perker' },
            { label: 'mehmet tezkan', value: 'mehmet tezkan' },
            { label: 'mehmet y yılmaz', value: 'mehmet y yılmaz' },
            { label: 'mehmet yalçın', value: 'mehmet yalçın' },
            { label: 'mehmet yaşin', value: 'mehmet yaşin' },
            { label: 'melih gümüşbıçak', value: 'melih gümüşbıçak' },
            { label: 'melih şabanoğlu', value: 'melih şabanoğlu' },
            { label: 'metin gürcan', value: 'metin gürcan' },
            { label: 'metin münir', value: 'metin münir' },
            { label: 'mine söğüt', value: 'mine söğüt' },
            { label: 'murat batı', value: 'murat batı' },
            { label: 'murat belge', value: 'murat belge' },
            { label: 'murat sabuncu', value: 'murat sabuncu' },
            { label: 'mustafa durmuş', value: 'mustafa durmuş' },
            { label: 'necmiye alpay', value: 'necmiye alpay' },
            { label: 'nehir günce daşcı', value: 'nehir günce daşcı' },
            { label: 'nurhayat gül', value: 'nurhayat gül' },
            { label: 'oğuz demiralp', value: 'oğuz demiralp' },
            { label: 'osman ulagay', value: 'osman ulagay' },
            { label: 'oya baydar', value: 'oya baydar' },
            { label: 'ömer faruk gergerlioğlu', value: 'ömer faruk gergerlioğlu' },
            { label: 'pınar doğu', value: 'pınar doğu' },
            { label: 'rıdvan akar', value: 'rıdvan akar' },
            { label: 'rıza türmen', value: 'rıza türmen' },
            { label: 'sami selçuk', value: 'sami selçuk' },
            { label: 'selçuk demirel', value: 'selçuk demirel' },
            { label: 'selçuk erez', value: 'selçuk erez' },
            { label: 'semra somersan', value: 'semra somersan' },
            { label: 'sencer ayata ', value: 'sencer ayata ' },
            { label: 'sertuğ çiçek', value: 'sertuğ çiçek' },
            { label: 'seyfettin gürsel', value: 'seyfettin gürsel' },
            { label: 'şirin payzın ', value: 'şirin payzın ' },
            { label: 'soli özel', value: 'soli özel' },
            { label: 'stelyo berberakis', value: 'stelyo berberakis' },
            { label: 'şükrü hatun', value: 'şükrü hatun' },
            { label: 'talat kırış', value: 'talat kırış' },
            { label: 'tan oral', value: 'tan oral' },
            { label: 'tayfun atay', value: 'tayfun atay' },
            { label: 'tolga şardan', value: 'tolga şardan' },
            { label: 'tolga şirin', value: 'tolga şirin' },
            { label: 'tuğçe tatari', value: 'tuğçe tatari' },
            { label: 'tuğrul akşar', value: 'tuğrul akşar' },
            { label: 'tuğrul eryılmaz', value: 'tuğrul eryılmaz' },
            { label: 'turgut kazan', value: 'turgut kazan' },
            { label: 'türkay demir', value: 'türkay demir' },
            { label: 'uğur gürses', value: 'uğur gürses' },
            { label: 'umur talu', value: 'umur talu' },
            { label: 'umut ozan darıcı', value: 'umut ozan darıcı' },
            { label: 'vecdi sayar', value: 'vecdi sayar' },
            { label: 'yalçın doğan', value: 'yalçın doğan' },
            { label: 'yılmaz murat bilican', value: 'yılmaz murat bilican' },
            { label: 'yusuf nazım', value: 'yusuf nazım' },
            { label: 'zeynel lüle', value: 'zeynel lüle' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'ahmet çelik kurtoğlu', value: 'ahmet çelik kurtoğlu' },
            { label: 'ahmet ergenç', value: 'ahmet ergenç' },
            { label: 'ahmet gürata', value: 'ahmet gürata' },
            { label: 'ahmet talimciler', value: 'ahmet talimciler' },
            { label: 'akdoğan özkan', value: 'akdoğan özkan' },
            { label: 'ali akay', value: 'ali akay' },
            { label: 'ali̇ bulunmaz', value: 'ali̇ bulunmaz' },
            { label: 'ali d. ulusoy', value: 'ali d. ulusoy' },
            { label: 'ali ihsan karacan', value: 'ali ihsan karacan' },
            { label: 'ali servet etkin', value: 'ali servet etkin' },
            { label: 'alex akimoğlu', value: 'alex akimoğlu' },
            { label: 'anıl özgüç', value: 'anıl özgüç' },
            { label: 'asena özkan', value: 'asena özkan' },
            { label: 'aslı kotaman', value: 'aslı kotaman' },
            { label: 'aslı öktener', value: 'aslı öktener' },
            { label: 'atilla dorsay', value: 'atilla dorsay' },
            { label: 'ayça atikoğlu', value: 'ayça atikoğlu' },
            { label: 'aydan çelik', value: 'aydan çelik' },
            { label: 'ayfer feriha nujen', value: 'ayfer feriha nujen' },
            { label: 'ayli̇n doğan', value: 'ayli̇n doğan' },
            { label: 'aysel sağır', value: 'aysel sağır' },
            { label: 'ayşe cemal', value: 'ayşe cemal' },
            { label: 'ayşe kadıoğlu', value: 'ayşe kadıoğlu' },
            { label: 'ayşe naz bulamur', value: 'ayşe naz bulamur' },
            { label: 'aziz çelik', value: 'aziz çelik' },
            { label: 'baran alp uncu', value: 'baran alp uncu' },
            { label: 'barçın yinanç', value: 'barçın yinanç' },
            { label: 'batuhan sarican', value: 'batuhan sarican' },
            { label: 'bbc', value: 'bbc' },
            { label: 'bekir ağırdır', value: 'bekir ağırdır' },
            { label: 'berrak göçer', value: 'berrak göçer' },
            { label: 'betül ertem yıldız', value: 'betül ertem yıldız' },
            { label: 'bi̇lge karasu', value: 'bi̇lge karasu' },
            { label: 'binhan elif yılmaz', value: 'binhan elif yılmaz' },
            { label: 'binnaz saktanber', value: 'binnaz saktanber' },
            { label: 'burak soyer', value: 'burak soyer' },
            { label: 'candan yıldız', value: 'candan yıldız' },
            { label: 'cansu çamlıbel', value: 'cansu çamlıbel' },
            { label: 'cebrail ötgün', value: 'cebrail ötgün' },
            { label: 'cem pekdoğru', value: 'cem pekdoğru' },
            { label: 'çağnur öztürk', value: 'çağnur öztürk' },
            { label: 'çağatay anadol', value: 'çağatay anadol' },
            { label: 'çiğdem toker', value: 'çiğdem toker' },
            { label: 'dw', value: 'dw' },
            { label: 'ebru d. dedeoğlu', value: 'ebru d. dedeoğlu' },
            { label: 'emre tansu keten', value: 'emre tansu keten' },
            { label: 'ercan uygur', value: 'ercan uygur' },
            { label: 'ercan y yilmaz', value: 'ercan y yilmaz' },
            { label: 'eray özer', value: 'eray özer' },
            { label: 'erdoğan sağlam', value: 'erdoğan sağlam' },
            { label: 'erol anar', value: 'erol anar' },
            { label: 'ertuğrul uzun', value: 'ertuğrul uzun' },
            { label: 'esra akgemci', value: 'esra akgemci' },
            { label: 'esin şenol', value: 'esin şenol' },
            { label: 'evren balta', value: 'evren balta' },
            { label: 'evri̇m altuğ', value: 'evri̇m altuğ' },
            { label: 'faruk bildirici', value: 'faruk bildirici' },
            { label: 'faruk ekici', value: 'faruk ekici' },
            { label: 'fatih türkmenoğlu', value: 'fatih türkmenoğlu' },
            { label: 'fikret ilkiz', value: 'fikret ilkiz' },
            { label: 'füsun sarp nebil', value: 'füsun sarp nebil' },
            { label: 'gökçen öz çelik', value: 'gökçen öz çelik' },
            { label: 'gökçer tahincioğlu', value: 'gökçer tahincioğlu' },
            { label: 'gözde yilmaz', value: 'gözde yilmaz' },
            { label: 'gürsel göncü', value: 'gürsel göncü' },
            { label: 'güneç kıyak', value: 'güneç kıyak' },
            { label: 'gündüz vassaf', value: 'gündüz vassaf' },
            { label: 'güven bayar', value: 'güven bayar' },
            { label: 'h. bader arslan', value: 'h. bader arslan' },
            { label: 'hakan okçal', value: 'hakan okçal' },
            { label: 'haluk erdem', value: 'haluk erdem' },
            { label: 'haluk şahin', value: 'haluk şahin' },
            { label: 'hasan cemal', value: 'hasan cemal' },
            { label: 'hasan göğüş', value: 'hasan göğüş' },
            { label: 'hasan öztürk', value: 'hasan öztürk' },
            { label: 'hayri cem', value: 'hayri cem' },
            { label: 'ibrahim dizman', value: 'ibrahim dizman' },
            { label: 'ilksen utlu', value: 'ilksen utlu' },
            { label: 'irfan yalın', value: 'irfan yalın' },
            { label: 'i̇skender aruoba', value: 'i̇skender aruoba' },
            { label: 'i̇smail küçükakyüz', value: 'i̇smail küçükakyüz' },
            { label: 'kevork altınkaya', value: 'kevork altınkaya' },
            { label: 'leyla alp', value: 'leyla alp' },
            { label: 'm. melih güneş', value: 'm. melih güneş' },
            { label: 'mehmet ali çiçekdağ', value: 'mehmet ali çiçekdağ' },
            { label: 'mehmet gürer', value: 'mehmet gürer' },
            { label: 'mehmet önal', value: 'mehmet önal' },
            { label: 'mehmet y yılmaz', value: 'mehmet y yılmaz' },
            { label: 'mehmet yaşin', value: 'mehmet yaşin' },
            { label: 'melike eğilmezler boylan', value: 'melike eğilmezler boylan' },
            { label: 'mine söğüt', value: 'mine söğüt' },
            { label: 'metin kaan kurtuluş', value: 'metin kaan kurtuluş' },
            { label: 'muammer brav', value: 'muammer brav' },
            { label: 'murat batı', value: 'murat batı' },
            { label: 'murat belge', value: 'murat belge' },
            { label: 'murat bjeduğ', value: 'murat bjeduğ' },
            { label: 'murat gülsoy', value: 'murat gülsoy' },
            { label: 'murat sabuncu', value: 'murat sabuncu' },
            { label: 'mustafa alp dağıstanlı', value: 'mustafa alp dağıstanlı' },
            { label: 'mustafa arslantunali', value: 'mustafa arslantunali' },
            { label: 'mustafa cihan camcı', value: 'mustafa cihan camcı' },
            { label: 'mustafa durmuş', value: 'mustafa durmuş' },
            { label: 'mustafa kavgacı', value: 'mustafa kavgacı' },
            { label: 'ni̇lüfer kuyaş', value: 'ni̇lüfer kuyaş' },
            { label: 'nazlı gülenç', value: 'nazlı gülenç' },
            { label: 'necmiye alpay', value: 'necmiye alpay' },
            { label: 'nehir günce daşcı', value: 'nehir günce daşcı' },
            { label: 'nurcan baysal', value: 'nurcan baysal' },
            { label: 'ozancan özdemir', value: 'ozancan özdemir' },
            { label: 'ömer önhon', value: 'ömer önhon' },
            { label: 'özge mumcu', value: 'özge mumcu' },
            { label: 'özlem yalım', value: 'özlem yalım' },
            { label: 'peri̇han mağden', value: 'peri̇han mağden' },
            { label: 'philippe soupault', value: 'philippe soupault' },
            { label: 'pınar okyay', value: 'pınar okyay' },
            { label: 'rıdvan akar', value: 'rıdvan akar' },
            { label: 'rıza türmen', value: 'rıza türmen' },
            { label: 'rengin soysal', value: 'rengin soysal' },
            { label: 'reşat ekrem koçu', value: 'reşat ekrem koçu' },
            { label: 'savaş kiliç', value: 'savaş kiliç' },
            { label: 'seda yılmaz', value: 'seda yılmaz' },
            { label: 'sefa kaplan', value: 'sefa kaplan' },
            { label: 'serdar gündoğ', value: 'serdar gündoğ' },
            { label: 'sezi̇n aydemi̇r', value: 'sezi̇n aydemi̇r' },
            { label: 'seçi̇l epi̇k', value: 'seçi̇l epi̇k' },
            { label: 'si̇bel oral', value: 'si̇bel oral' },
            { label: 'suzy hansen', value: 'uzy hansen' },
            { label: 'svetlana aleksiyeviç', value: 'svetlana aleksiyeviç' },
            { label: 'şükrü hatun', value: 'şükrü hatun' },
            { label: 't24 haber merkezi', value: 't24 haber merkezi̇' },
            { label: 'tan oral', value: 'tan oral' },
            { label: 'tarık ziya ekinci', value: 'tarık ziya ekinci' },
            { label: 'thomas taylor', value: 'thomas taylor' },
            { label: 'tolga şardan', value: 'tolga şardan' },
            { label: 'tolga şirin', value: 'tolga şirin' },
            { label: 'tuğrul eryılmaz', value: 'tuğrul eryılmaz' },
            { label: 'tuncay bi̇rkan', value: 'tuncay bi̇rkan' },
            { label: 'turgut yüksel', value: 'turgut yüksel' },
            { label: 'tuğçe tatari', value: 'tuğçe tatari' },
            { label: 'tuğrul akşar', value: 'tuğrul akşar' },
            { label: 'tuğçe isiyel', value: 'tuğçe isiyel' },
            { label: 'ümit aslanbay', value: 'ümit aslanbay' },
            { label: 'ümit kartoglu', value: 'ümit kartoglu' },
            { label: 'umur talu', value: 'umur talu' },
            { label: 'vedat özdan', value: 'vedat özdan' },
            { label: 'volkan vural', value: 'volkan vural' },
            { label: 'yalçın doğan', value: 'yalçın doğan' },
            { label: 'yusuf eradam', value: 'yusuf eradam' },
            { label: 'yusuf nazım', value: 'yusuf nazım' },
            { label: 'yıldız tar', value: 'yıldız tar' },
            { label: 'zeynel lüle', value: 'zeynel lüle' },
            { label: 'zeynep miraç', value: 'zeynep miraç' },
            { label: 'zeynep yıldırım', value: 'zeynep yıldırım' },
            { label: 'zeynep özaltin', value: 'zeynep özaltin' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterT24Object = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
